export default {
  journeys: [],
  journey: null,
  loading: false,
}
